//通用函数
import smCom from './global/smCom.js';
//数字函数
import numHelper from './global/numHelper.js';
//时间函数
import timeHelper from './global/timeHelper.js';


//
//后台接口
import smCloud from './api/smCloud.js';
import smCloudApi from './api/smCloudApi.js';
// import newSmApi from './api/newSmApi.js';
// smCommon


export default {

  smCom, //通用函数
  numHelper, //数字函数
  timeHelper, //时间函数
  smCloud, //后台接口
  smCloudApi, //云端绑定/短信
  // newSmApi, //后台接口
  //公用函数
}



//////////////////
// WEBPACK FOOTER
// ./common/api.js
// module id = null
// module chunks = 